import { accessUserAPI, loginAPI, logoutAPI } from "@/apis/auth-api"
import { create } from "zustand"
import { aptSearchStore } from "../select/apt/apt-search-store"

export const authStore = create((set, get) => ({
  user_id: null,
  user_name: null,
  sido_key: null,
  scope_type: null,
  scope_code: null,
  scope_codes: [],
  role: null,
  exp: null,

  isAuthenticated: false,

  setAuth: ({ user_id, user_name, sido_key, scope_type, scope_code, scope_codes, role, exp }) =>
    set({
      user_id,
      user_name,
      sido_key,
      scope_type,
      scope_code,
      scope_codes,
      role,
      exp,
      isAuthenticated: true
    }),

  setUserName: (user_name) => set({ user_name }),

  apiLogin: async ({ user_id, password }) => {
    const { user, apt_info } = await loginAPI({
      user_id,
      password
    })

    get().setAuth(user)

    if (apt_info) {
      aptSearchStore.getState().setPickApt({
        ...apt_info,
        sido: user.sido_key
      })
    }

    return !!user
  },

  accessUserCheck: async () => {
    try {
      const user = await accessUserAPI()
      if (!user) {
        get().clearAuth()
        return null
      }

      get().setAuth(user)

      return user
    } catch {
      get().clearAuth()
      return null
    }
  },

  apiLogout: async () => {
    const success = await logoutAPI()

    if (success) {
      get().clearAuth()
    }

    aptSearchStore.getState().pickReset()

    return success
  },

  clearAuth: () =>
    set({
      user_id: null,
      user_name: null,
      sido_key: null,
      scope_type: null,
      scope_code: null,
      scope_codes: [],
      role: null,
      exp: null,
      isAuthenticated: false
    })
}))
